import { useMutation, useQueryClient } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { statementItemRepository } from '@webapp/modules/accounts-payable/data-access/repositories/StatementItemRepository'
import { StatementItem } from '@webapp/modules/accounts-payable/entities/StatementItem'
import { STATEMENT_ITEM_UNMATCHED_BASE_KEY } from '@webapp/modules/accounts-payable/query-configs/statementItemQueries'

export const useMutateDuplicateStatementItem = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation<StatementItem, RepoError, StatementItem>({
    // Duplicate = re-POST of the source row's fields (BHV-042).
    mutationFn: async (source) =>
      new StatementItem(
        await statementItemRepository.create({
          creditcardId: source.creditcardId,
          description: source.description,
          date: source.date,
          amount: source.amount,
        })
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: STATEMENT_ITEM_UNMATCHED_BASE_KEY,
      })
    },
  })

  return {
    duplicateStatementItem: mutation.mutateAsync,
    isDuplicating: mutation.isLoading,
    error: mutation.error,
  }
}
